var exports = {
  "kL": "x127c5a35--4fdeaa--container",
  "UU": "x127c5a35--4fdeaa--name",
  "z": "x127c5a35--4fdeaa--full_width",
  "et": "x127c5a35--4fdeaa--transport",
  "gO": "x127c5a35--4fdeaa--ellipsis",
};

module.exports = exports;
